<ng-template [cdkPortalOutlet]="portal"></ng-template>
<div class="dca-scrollarea">
    <sf-author-list></sf-author-list>
</div>
